import { Component, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { XpoConditionBase } from '../../../../validations/validations.class';
import { XpoFilterCondition } from '../../../condition';
import { IsBetweenModel } from '../../model.interface';
import { HourFormatErrorEvent } from '../shared/exact-time-input/hour-format-error-event';
import { ordersMinMaxTime } from '../time.util';
import {
  CustomFilterParams,
  filterFormats,
  Operators,
  OperatorText,
  XpoFilterConditionCriteria,
} from './../../../../../models/index';

@Component({
  templateUrl: './not-between.component.html',
  styleUrls: ['../../validator.scss'],
})
export class XpoConditionTimeNotBetweenComponent extends XpoConditionBase implements XpoFilterCondition {
  static text: string = OperatorText.NotBetween;
  static operator: Operators = Operators.NotBetween;
  isNegative = false;
  model: IsBetweenModel = {
    from: '',
    to: '',
  };
  format24Error: boolean = false;

  // TODO: This is to solve the issue with moment taking full date values only and is meant to be redone
  // in a more correct manner
  fakeDate = '01/01/2020';

  is24Hour: boolean = false;
  @Output() inputChanged = new EventEmitter();

  set customFilterParams(params: CustomFilterParams) {
    this.is24Hour = params.is24HourFormat;

    // TODO: this fill be fixed when refactoring this whole thing
    if (!this.is24Hour) {
      this.changeFormat(filterFormats.default);
    }
  }

  constructor() {
    super(filterFormats.stringRange);
  }

  validate(cellValue): boolean {
    // Do not validate if input is empty
    if (!this.model) {
      return true;
    }

    if (!cellValue) {
      return false;
    }

    const cell = moment(`${cellValue} ${this.fakeDate}`).format('HH:mm');
    const ordered = ordersMinMaxTime(this.model.from, this.model.to);

    return (
      (ordersMinMaxTime(cell, ordered.from).from === cell && ordered.from !== cell) ||
      (ordersMinMaxTime(ordered.to, cell).to === cell && ordered.to !== cell)
    );
  }

  getCriteria(): XpoFilterConditionCriteria {
    const ordered = ordersMinMaxTime(this.model.from, this.model.to);
    return {
      operator: Operators.NotBetween,
      value: ordered.from,
      valueTo: ordered.to,
    };
  }

  onFromInputChange(value): void {
    if (!value || !value.length) {
      return;
    }
    this.model.from = value;
    this.onInputChange();
  }

  onToInputChange(value): void {
    this.model.to = value;
    this.onInputChange();
  }

  onInputChange(): any {
    // TODO: this fill be fixed when refactoring this whole thing
    if (this.is24Hour) {
      this.validateFormat();
    }

    this.inputChanged.emit(this.model);
  }
}
